/* eslint-disable max-len */

import React from 'react'
import { FormattedMessage } from 'react-intl'

import { UNIT_TYPES } from 'constants'

export const SORTIES_END_INTERIM = 5 * 60 * 1000 // 5 minutues

export const BATTLE_TITLE_TOOLTIPS_ID = {
    [UNIT_TYPES.SORTIE]: 'sortie_title_tooltip',
    [UNIT_TYPES.FORT_BATTLE]: 'fort_battle_title_tooltip',
}

export const BATTLE_WIZARD_REWARD_TOOLTIP = (
    <FormattedMessage
        id='battle_wizard.reward.tooltip'
        defaultMessage='Награда за захват Цитадели противника.'
    />
)

export const BATTLE_WIZARD_REWARD_TOOLTIP_X2 = (
    <FormattedMessage
        id='battle_wizard.reward.tooltip_x2'
        defaultMessage='Награда за захват Цитадели противника (с учётом х2 за первую победу).'
    />
)


export const STATIC_TOOLTIPS_ID = {
    sortie_reward: 'battle-wizard-sortie-reward-tooltip',
    per_battle: 'battle-wizard-per-battle-reward-tooltip',
    vehicle_levels: 'battle-wizard-vehicle-levels-tooltip',
    players_count: 'battle-wizard-players-count-tooltip',
    legionaries_count: 'battle-wizard-legionaries-count-tooltip',
    fort_battle_duration: 'battle-wizard-fort-battle-duration-tooltip',
    sortie_duration: 'battle-wizard-sortie-duration-tooltip',
}

export const STATIC_TOOLTIPS_MESSAGES = {
    sortie_reward: (
        <FormattedMessage
            id='battle_wizard.sortie_reward_tooltip'
            defaultMessage='Награда, которая делится между кланами в вылазке. Победитель получает основную долю награды.'
        />
    ),
    per_battle: (
        <FormattedMessage
            id='battle_wizard.per_battle_reward_tooltip'
            defaultMessage='Награда в каждом бою, которая делится между кланами.'
        />
    ),
    vehicle_levels: (
        <FormattedMessage
            id='battle_wizard.vehicle_levels_tooltip'
            defaultMessage='Уровни техники в бою'
        />
    ),
    players_count: (
        <FormattedMessage
            id='battle_wizard.players_count_tooltip'
            defaultMessage='Количество игроков в отряде, включая легионеров'
        />
    ),
    legionaries_count: (
        <FormattedMessage
            id='battle_wizard.legionaries_count_tooltip'
            defaultMessage='Максимальное количество легионеров в отряде'
        />
    ),
    fort_battle_duration: (
        <FormattedMessage
            id='battle_wizard.fort_battle_duration_tooltip'
            defaultMessage='Максимальная длительность одного боя и всего Наступления'
        />
    ),
    sortie_duration: (
        <FormattedMessage
            id='battle_wizard.sortie_duration_tooltip'
            defaultMessage='Максимальная длительность боя'
        />
    ),
}

export const TOOLTIP_FOOTER = (
    <FormattedMessage
        id='battle_tooltip.click'
        defaultMessage='Нажмите, чтобы создать отряд'
    />
)

export const TOOLTIP_BACK_FOOTER = (
    <FormattedMessage
        id='battle_tooltip.back'
        defaultMessage='Нажмите, чтобы вернуться к отряду.'
    />
)

export const TOOLTIP_FOOTER_REBUILD = (
    <FormattedMessage
        id='battle_tooltip.rebuild'
        defaultMessage='Нажмите, чтобы сменить режим.'
    />
)



// WEBPACK FOOTER //
// ./components/BattleWizard/constants.jsx